import React from 'react';
import { Navigate } from 'react-router-dom';

import APIRepoContributePage from './APIRepoContributePage';
import { useApiAccess } from '../../Contexts/ApiAccessProvider';

const ProtectedContributorApiPage = ({ active }) => {
    const { apiAccessRole, apiAccessLoading } = useApiAccess()

    if (apiAccessLoading) {
        // Optional: You can show a spinner or skeleton loader here
        return <div className="flex items-center justify-center h-screen w-full">
            <div className="w-12 h-12 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
        </div>;
    }

    if (apiAccessRole) {
        return <APIRepoContributePage active={active} />;
    }

    return <Navigate to="/dashboard" />;
};

export default ProtectedContributorApiPage;
